import React, { useState } from 'react';

function usePersistedState<T>(key: string, initialValue: T): [T, React.Dispatch<T>] {
    const [storedValue, setStoredValue] = useState<T>(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            return initialValue;
        }
    });

    const setValue = (value: T) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            return window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            return initialValue;
        }
    };

    return [storedValue, setValue];
}

export default usePersistedState;
